import { createGlobalStyle } from 'styled-components';

export const OverwriteAntdGlobalStyle = createGlobalStyle`
  .ant-btn-ghost {
    background-color: var(--bg-container);
  }
  .ant-table-content {
    overflow-x: auto !important;
    overflow-y: hidden;
  }

  .ant-table-thead {
    th {
      background: var(--bg-content) !important;
      color: var(--text-tab-title)  !important;
      font-weight: 500;
      font-size: 12px;
      text-transform: uppercase;
    }
    td {
      background: var(--bg-content) !important;
    }
  }
  .ant-table-row-selected >.ant-table-cell {
    background: var(--border-color-light) !important;
  }
  .popover-inner-0 {
    .ant-popover-inner {
      padding:0px;
    }
  }

  .btn-light {
    background:var(--border-color-light);
    border-color:var(--border-color-light);
  }

  .btn-primary-light {
    background: var(--light-primary);
    border-color: var(--border-color-primary);
    color: var(--primary);
  }

  .btn-primary-light-no-border {
    background: var(--light-primary);
    color: var(--primary);
  }

  .btn-h-32 {
    padding: 0 14px;
    height: 32px;
    min-width: 76px;
    font-size: 14px;
    font-weight: 600;
  }

  .ant-menu-item-selected {
    &::before {
      width: 2px;
      height: 30px;
      background:red;
      content: "";
    }
  }

  .ant-tag-primary {
    background:var(--bg-light) !important;
    color:var(--primary) !important;
    border: none;
    border-radius: 5px;
    .anticon {
      color: var(--primary);
    }
  }
  .ant-tag-secondary {
    background:var(--bg-secondary-light) !important;
    color:var(--secondary) !important;
  }

  .ant-form-item {
    margin-bottom: 20px;
  }
  
  .ant-form-item-label {
    font-weight: 600;
    /* font-size: 12px; */
  }

  .edit-options {
    .ant-dropdown-menu-item {
      padding: 0 !important;
    }

    .ant-btn-link {
      color: #000000 !important;
      width: 100% !important;
      text-align: left !important; 
    }
  }

  .ant-modal-confirm-body-wrapper {
    padding: 20px 24px !important;
  }

  .ant-modal {
    padding:0px;
    .ant-modal-content {
      padding:0px;
    }
    .ant-modal-header{
      padding: 17px 23px;
      border-bottom: 1px solid var(--border-color-light);
      margin-bottom:0px;
    }
    .ant-modal-body {
      padding: 17px 23px;
    }
    .ant-modal-footer {
      padding: 17px 23px;
      border-top: 1px solid var(--border-color-light);
    }
  }

  .ant-btn-primary {
    &.ant-btn-background-ghost {
      background: var(--bg-light);
    }
  }

  .ant-tabs-card {
    .ant-tabs-tab {
      padding: 8px 16px !important;
      border-radius: 4px 4px 0 0 !important;
    }

    .ant-tabs-tab-active .ant-tabs-tab-btn {
      color: var(--color-red) !important;
      font-weight: bold !important;
    }
  }

  .qrCode-modal {
    .ant-modal-body {
      padding: 32px 32px 24px !important;
    }
    .ant-modal-confirm-paragraph {
      width: 100%;
      max-width: none;
    }

    .ant-modal-confirm-btns {
      margin-top: 24px;
    }

    .ant-btn-primary {
      background-color: var(--primary);

      &:hover {
        background-color: var(--primary) !important;
        opacity: 0.8;
      }
    }
  }
  .ant-table-measure-row {
    td {
      padding: 0px !important;
    }
  }

  .ant-table .ant-table-cell-ellipsis {
    white-space: normal;
  }

  .ant-table .ant-typography {
    margin-bottom: 0;
  }

  .location-listing .ant-switch .ant-switch-handle {
    transition: none !important;
  }

  .ant-modal-confirm-btns, .ant-modal-confirm-title {
    button {
      border-radius: var(--border-radius);
      /* height: 40px; */
    }
    .ant-btn-primary,
    .ant-btn-primary:hover {
      background-color: var(--primary) !important;
      color: #ffffff !important;
    }
    .ant-btn-default {
      border-color: var(--border-color);
    }
    .ant-btn-default:hover {
      border-color: var(--primary) !important;
      color:  var(--primary) !important;
    }
  }
  .custom-tabs {
    .ant-tabs-nav {
      background: #fff;
      padding-left: 10px;
      .ant-tabs-tab {
        opacity: 0.4;
      }
      .ant-tabs-tab-active {
        opacity: 1;
      }
    }
  }
  .ant-input-number, .ant-input-number-affix-wrapper, .ant-picker {
    width: 100%;
  }

  .slick-dots .slick-active button {
    border: 1px solid #fff !important;
    border-radius: 50%;
    background:#000 !important;
  }

  .form-item-d-none {
    margin-bottom: 0 !important;
    .ant-form-item-control-input {
      display: none;
    }
  }
  .tooltip-export {
    .ant-tooltip-inner {
      background: #ffffff;
      padding: 20px;
      width: 100%;
    }
  }
    .ant-btn-primary {
    &:hover {
      background: var(--primary) !important;
    }
    }
`;
